export enum LinkTargetType {
  BLANK = "_blank",
  SELF = "_self",
}
export interface OpenInTargetTabType {
  allLinksTarget: LinkTargetType; // convert all links into desired target, default is unchanged
  checkoutInNewTab: boolean; // open checkout page from hotel detail, default is false
  markerPopUp: LinkTargetType; // Specific for hotel details popup target link
}
